import { render, staticRenderFns } from "./SetupInfo.vue?vue&type=template&id=b6b76f64&scoped=true"
import script from "./SetupInfo.vue?vue&type=script&lang=js"
export * from "./SetupInfo.vue?vue&type=script&lang=js"
import style0 from "./SetupInfo.vue?vue&type=style&index=0&id=b6b76f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b76f64",
  null
  
)

export default component.exports